import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import ChooseArgsDialog from "../Dialogs/ChooseArgsDialog";
import { Edit } from "@mui/icons-material";
import ingredients from "../../Assets/Icons/ingredients.png";
import grain from "../../Assets/Icons/rice.png";
import powder from "../../Assets/Icons/salt.png";
import oil from "../../Assets/Icons/oil.png";
import paste from "../../Assets/Icons/sause.png";
import water from "../../Assets/Icons/water.png";
import bowl from "../../Assets/Icons/bowl.png";
import { validIngredientTaskTypes } from "../../constants";

export default function IngredientButton({
  task,
  onUpdate,
  isAuthor,
  fromViewPage,
}) {
  const [open, setOpen] = React.useState(false);
  const onClose = () => setOpen(false);

  const theme = useTheme(); // Access the theme


  const isTypeValid = validIngredientTaskTypes.includes(task.type);
  let ingredientImage;
  if (task.type === "choose_grains") {
    ingredientImage = grain;
  } else if (task.type === "choose_spices") {
    ingredientImage = powder;
  } else if (task.type === "choose_oil") {
    ingredientImage = oil;
  } else if (task.type === "choose_paste") {
    ingredientImage = paste;
  } else if (task.type === "choose_bowl") {
    ingredientImage = bowl;
  } else if (task.type === "choose_water") {
    ingredientImage = water;
  } else {
    ingredientImage = ingredients;
  }
  

  return (
    <Stack
      direction={"row"}
      sx={{
        width: "100%",
        padding: theme.spacing(1),
        borderBottom: "1px solid #ccc",
      }}
    >
      <img src={ingredientImage} width={"30px"} height={"30px"} alt="ingredient" />
      <Stack
        direction={"column"}
        sx={{
          flexGrow: 1,
          marginLeft: theme.spacing(2),
        }}
      >
        <Typography
          variant="body1"
          component="div"
          sx={{
            display: "block",
            fontWeight: "bold",
            color: theme.palette.primary.main,
          }}
        >
          {task.item_name}
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{
            display: "block",
            color: theme.palette.text.secondary,
          }}
        >
          {`${task.quantity || ""} ${task.unit || ""}`}
        </Typography>
      </Stack>
      {isTypeValid && isAuthor && !fromViewPage && (
        <Button
          onClick={() => setOpen(true)}
          variant="outlined"
          size="small"
          sx={{
            width: "30px",
            height: "30px",
            minWidth: "30px",
            padding: "0",
            borderRadius: "50%",
            border: "none",
            backgroundColor: theme.palette.background.default,
            "&:hover": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        >
          <Edit sx={{ fontSize: "18px" }} />
        </Button>
      )}
      {isTypeValid && isAuthor && (
        <ChooseArgsDialog
          open={open}
          onClose={onClose}
          task={task}
          onUpdate={onUpdate}
        />
      )}
    </Stack>
  );
}

IngredientButton.propTypes = {
  task: PropTypes.shape({
    type: PropTypes.string.isRequired,
    args: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    item_name: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }).isRequired,
  onUpdate: PropTypes.func.isRequired,
  isAuthor: PropTypes.bool.isRequired,
  fromViewPage: PropTypes.bool.isRequired,
};
